import styled, {css} from 'styled-components';
import {Anchor} from 'shared/components/Sidebar/Sidebar';

export const SidebarTab = styled.button<{$anchor: Anchor}>`
    position: absolute;
    top: 15%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 15px;
    height: 48px;
    padding: 0;
    border: 1px solid #e0e0e0;
    background: #f4f3f2;
    cursor: pointer;

    ${({$anchor}) =>
        $anchor === 'RIGHT'
            ? css`
                  left: -15px;
                  border-right: 0;
                  border-radius: 8px 0 0 8px;
                  box-shadow: #b5b5b5 -14px 3px 18px -7px;
              `
            : css`
                  right: -15px;
                  border-left: 0;
                  border-radius: 0 8px 8px 0;
                  box-shadow: #b5b5b5 14px 3px 18px -7px;
              `}

    &:hover {
        background: #f8f9fa;
    }

    > img {
        width: 14px;
    }
`;
